import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getPvcPdf } from '../actions/api';
import printIcon from '../images/print-icon.png';

class PrintPVCButton extends Component {
    onClickPDF =()=>{
        let userId= null;
        if(this.props.selectedUser.isDependent){
            userId = this.props.selectedUser.id;
        }

        this.props.dispatch(getPvcPdf(userId));
    }
    render() {
        return (
            <div >
                <button class={"btn vacc-btn btn-lg btn-block"} onClick={() => this.onClickPDF()}>
                    <img src={printIcon} width="18px"/>&nbsp;
                    {this.props.strings.PRINT_VAX_BUTTON}
                </button>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        strings: state.language.strings,
        deviceType: state.api.deviceType,
        selectedUser: state.api.selectedUser,
    }
}

export default connect(mapStateToProps)(PrintPVCButton)